export const styles = {
  pageHeader: {
    backgroundColor: `var(--white)`,
    padding: '18px 32px',
  },
  buttonBack: {
    background: `var(--fill-cards)`,
    borderRadius: '4px',
  },
  title: {
    maxWidth: '60%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 500,
    fontSize: '24px',
  },
  buttons: {
    marginLeft: 'auto',
  },
}
